
import { RevButtonBase } from '@ds/components/ButtonBase'
import { RevButtonTiny } from '@ds/components/ButtonTiny'
import { RevCard } from '@ds/components/Card'
import { RevDivider } from '@ds/components/Divider'
import { RevIllustration } from '@ds/components/Illustration'
import { IconChevronRight } from '@ds/icons/IconChevronRight'

import IllustrationCashHandCroppedBottomLeft from '@core/illustrations/IllustrationCashHandCroppedBottomLeft.svg'
import IllustrationCashHandCroppedRight from '@core/illustrations/IllustrationCashHandCroppedRight.svg'

import productcardcontainertranslations from '../ProductCardContainer.translations'

import translations from './HighlightedProductCard.translations'

export default {
  components: {
    IllustrationCashHandCroppedBottomLeft,
    IllustrationCashHandCroppedRight,
    RevButtonBase,
    RevButtonTiny,
    RevDivider,
    RevIllustration,
    RevCard,
  },

  props: {
    attributes: {
      default: () => [],
      type: Array,
    },
    description: {
      required: true,
      type: String,
    },
    warranty: {
      default: '',
      type: String,
    },
    imageAlt: {
      required: true,
      type: String,
    },
    imageSrc: {
      required: true,
      type: String,
    },
    link: {
      required: true,
      type: Object,
    },
    percentageDifference: {
      default: undefined,
      type: Number,
    },
    price: {
      required: true,
      type: Object,
    },
    title: {
      required: true,
      type: String,
    },
    variant: {
      default: 'default',
      type: String,
    },
  },

  data() {
    return {
      isFocused: false,
    }
  },

  computed: {
    IconChevronRight: () => IconChevronRight,
    isVariantDefault() {
      return this.variant === 'default'
    },
    isVariantListView() {
      return this.variant === 'listView'
    },
    translations: () => ({
      ...translations,
      ...productcardcontainertranslations,
    }),
    attributesToDisplay() {
      return this.attributes?.map(({ attributes, label }) => ({
        label,
        value: attributes || this.$t(translations.notDefinedAttribute),
      }))
    },
  },
  methods: {
    isMultipleOfThree: (index) => {
      return (index + 1) % 3 === 0
    },
  },
}
